import { Component, OnInit } from '@angular/core';
import { FormComponentLookup, FormNavigationConfig, DefaultFormConfig, FormPageComponentClass } from '@ptl/forms';
import { PtlNotificationService, PtlNotificationStyle } from '@ptl/global-components';
import { DocumentOrderRequestPayload } from './interfaces/doc-order-form.interface';
import { DocumentOrderFormService } from './services/document-order-form.service';
import { DocumentOrderFormBuilderService } from './services/document-order-form-builder.service';

@FormComponentLookup('page-document-order-form')
@Component({
    selector: 'app-document-order-form',
    templateUrl: './document-order-form.component.html',
    styleUrls: ['./document-order-form.component.scss'],
    standalone: false
})
export class DocumentOrderFormComponent extends FormPageComponentClass<FormNavigationConfig> implements OnInit {
  
  isLoading = false;

  constructor(
    private ptlNotificationService: PtlNotificationService,
    private documentOrderFormService: DocumentOrderFormService,
    private documentFormBuilderService: DocumentOrderFormBuilderService
  ) {
    super();
  }

  ngOnInit() {
    // Add all of the configured form checkboxes configured in formConfig.form.customConfigs
    this.documentFormBuilderService.buildDocumentCheckboxes(this.formConfig);

    this.initPageConfig();
  }

  submitHook(formConfig) {
    return new Promise((resolve, reject) => {

      this.isLoading = true;

      this.documentOrderFormService.submitDocumentRequest(this.getDocumentPayload()).then((response) => {
          this.ptlNotificationService.open({
            title: 'Thank You',
            content: 'Your request has been submitted!',
            primaryButtonText: 'OK',
            notificationStyle: PtlNotificationStyle.SUCCESS
          });

          this.resetAllForms();
      })
      .catch((error) => {
        this.ptlNotificationService.open({
          title: 'Error Submitting Request',
          content: 'A network error occurred. Please try again later or contact support.',
          primaryButtonText: 'OK',
          notificationStyle: PtlNotificationStyle.DANGER
        });
      })
      .finally(() => {
        this.isLoading = false;
        resolve(true);
      });
    });
  }

  getDocumentPayload() {
    let formVal = this.pageFormGroups['docOrderForm'].value;
    let payload: DocumentOrderRequestPayload = {
      year: formVal.year,
      firstName: formVal.firstName,
      lastName: formVal.lastName,
      address1: formVal.address1,
      address2: formVal.address2,
      city: formVal.city,
      state: formVal.state,
      zip: formVal.zip,
      bookRequested: formVal.type,
      
      // These are extracted below
      directory: '',
      evidenceOfCoverage: [],
      annualNoticeOfChange: null,
      directoryLabel: '',

      // TODO-not sure if these are needed for some use case I have not come across
      umi: null,
      group: null,
      requestType: null
    };

    if (formVal.type == 'Directory') {
      let valueSplit = formVal.providerDirectory.split('##');
      payload.directory = valueSplit[0];
      payload.directoryLabel = valueSplit[1];
    }
    else if (formVal.type == 'Dental Directory') {
      let valueSplit = formVal.dentalDirectory.split('##');
      payload.directory = valueSplit[0];
      payload.directoryLabel = valueSplit[1];
    }
    else if (formVal.type === 'Evidence of Coverage') {
      let selectedKeys = this.getSelectedDocumentKeys(formVal);
      selectedKeys.forEach((key) => {
        payload.evidenceOfCoverage.push({
          planName: this.getLabelFromFormControl(key),
          planId: key
        });
      });
    }
    else if (formVal.type === 'Annual Notice of Changes') {
      let selectedKeys = this.getSelectedDocumentKeys(formVal);
      payload.annualNoticeOfChange = [];
      selectedKeys.forEach((key) => {
        payload.annualNoticeOfChange.push({
          label: this.getLabelFromFormControl(key),
          value: key
        });
      });
    }

    return payload;
  }

  getLabelFromFormControl(name: string): string {
    let entry = this.formConfig.pages[0].entries.filter((entry) => entry.formControlAttributes?.formControlName === name)[0];
    return entry.formControlAttributes.label;
  }

  getSelectedDocumentKeys(formVal: any) {
    let keyList = [];
    let allKeys = Object.keys(formVal);
    allKeys.forEach((key) => {
      if (formVal[key] === true) {
        keyList.push(key);
      }
    });

    return keyList;
  }
}
